import { a as o, j as c } from "../../../jsx-runtime-c20f6c15.mjs";
import i from "clsx";
import a from "../../../shared/icons/close-x.svg.mjs";
import u from "../Button/Button.mjs";
import "react";
import "../Spinner/Spinner.mjs";
const _ = "_alert_wjluz_9", d = "_fadeIn_wjluz_1", m = "_dismissible_wjluz_17", f = "_close_wjluz_21", j = "_success_wjluz_40", p = "_danger_wjluz_46", s = {
  alert: _,
  fadeIn: d,
  dismissible: m,
  close: f,
  success: j,
  danger: p
};
function h({
  children: t,
  className: r,
  type: l = "default",
  isOpen: n,
  toggle: e
}) {
  return n ? /* @__PURE__ */ o(
    "div",
    {
      className: i(
        s.alert,
        {
          [s.success]: l === "success",
          [s.danger]: l === "danger"
        },
        !!e && s.dismissible,
        r
      ),
      children: [
        !!e && /* @__PURE__ */ c(u, { className: s.close, type: "button", onClick: e, plain: !0, children: /* @__PURE__ */ c(a, {}) }),
        t
      ]
    }
  ) : null;
}
export {
  h as default
};
